import { render, staticRenderFns } from "./CardItemPreviewOffering.vue?vue&type=template&id=704a75b7&scoped=true"
import script from "./CardItemPreviewOffering.vue?vue&type=script&lang=js"
export * from "./CardItemPreviewOffering.vue?vue&type=script&lang=js"
import style0 from "./CardItemPreviewOffering.vue?vue&type=style&index=0&id=704a75b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704a75b7",
  null
  
)

export default component.exports